
export const ADD_PART = 'ADD_PART'
export const REMOVE_PART = 'REMOVE_PART'
export const CLEAR_CART = 'CLEAR_CART'
export const SET_FULL_PARTS = 'SET_FULL_PARTS'
export const SET_LOADING = 'SET_LOADING'
export const UPDATE_PART = 'UPDATE_PART'

export const SET_CART = 'SET_CART'
export const SET_CART_PRODUCTS = 'SET_CART_PRODUCTS'
